//import Account from './../../Resources/script.js'
import commonfunctions from "../../Resources/commonfunctions";

export default {
    name: 'Account',
    mixins: [commonfunctions],
    data () {
        return {
            //sellpoint:{},
            //categories:{},
        }
    },

    components: {
        
    },
     
    methods: {
        setPage(){
            this.loadCategories();
        },

        setMoreDetails(){},

        setCategory(data){
            this.$store.dispatch('account/setCategory',data);
            this.$router.push('/account/business/category');
        },
        
        setProduct(data){
            this.$store.dispatch('account/setProduct',data);
            this.$router.push('/account/business/product');
        },
      
    },

    created: function(){
        this.setPage();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/Categories/script.js